import {
  DEFAULT_ERROR_CODE,
  DEFAULT_ERROR_CODE_NAME,
} from '../../backend/src/api/v1/api-error';

export const fetchBackend = async (...args) => {
  try {
    const response = await fetch(...args);
    return {
      code: response.headers.get('X-Response-Code') || DEFAULT_ERROR_CODE,
      codeName:
        response.headers.get('X-Response-Codename') || DEFAULT_ERROR_CODE_NAME,
    };
  } catch {
    return {
      code: DEFAULT_ERROR_CODE,
      codeName: DEFAULT_ERROR_CODE_NAME,
    };
  }
};
